import React, {Component} from "react"
import {Link} from "react-router-dom"

import {Product} from "~/utils/ShelfEntities"
import {handleDestroyError} from "."
import Button from "~/components/Button"
import {withTranslation} from "react-i18next"

const icon = require("~/icons/product_32_blue.svg")
const icon_delete = require("~/icons/action_delete.svg")
const icon_edit = require("~/icons/action_edit.svg")

class ListItemProduct extends Component {
  destroyProduct() {
    if (
      window.confirm(this.props.t("articles.detail.deleteProductConfirmation"))
    ) {
      Product.destroy(this.props.id)
        .then(() => this.props.update())
        .catch(handleDestroyError)
    }
  }
  render() {
    return (
      <div className="sh-list-item">
        <img src={icon} alt={"Product"} />
        <div className={"content"}>
          <Link to={`/product/${this.props.id}`}>
            <div className="primary">{this.props.name}</div>
            {this.props.serial_number && (
              <div className="secondary">
                {this.props.t("articles.detail.articleNumber")}{" "}
                {this.props.serial_number}
              </div>
            )}
          </Link>
        </div>

        {!this.props.disableActions && (
          <div className="actions">
            <Button
              onClick={this.destroyProduct.bind(this)}
              icon={icon_delete}
              label={this.props.t("articles.detail.delete")}
            />
            <Button
              to={"/products/" + this.props.id}
              icon={icon_edit}
              label={this.props.t("articles.detail.edit")}
            />
          </div>
        )}
      </div>
    )
  }
}

export default withTranslation()(ListItemProduct)



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemProduct.js